export function initHeader() {
    $('.nav-item').on("click", function () {
        if($('.navbar-collapse.ml-auto.collapse').hasClass('show')){
            $('.navbar-toggler').click();
        }
    });
};